// extracted by mini-css-extract-plugin
module.exports = {"headline":"AddTask_headline__3xKf0","headline-2":"AddTask_headline-2__1LMsS","input":"AddTask_input__3hDE7","button":"AddTask_button__iTxeN"};